import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { contactsList } from '../../store/contacts/actions';
import { gestionesContactoList } from '../../store/gestionesContacto/actions';
import AgentDashboard from './components/AgentDashboard';
import AdminDashboard from './components/AdminDashboard';
import './Dashboard.css';

const Dashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch initial data
    dispatch(contactsList());
    dispatch(gestionesContactoList());
  }, [dispatch]);

  // Get user groups from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = user ? String(user.groups[0]?.[0]) : '';

  if (groups === "Agente") {
    return <AgentDashboard />;
  }

  // All other roles (SuperAdmin, Administrador, Supervisor, etc.) see AdminDashboard
  return <AdminDashboard />;
};

export default Dashboard;